import React from "react";
import { Col } from "antd";
import { ButtonTags } from "../../common/ButtonTags";

import {
	EachBoxListingWrapper,
	FlexDiv,
	SecStartedContent,
} from "../../../styleComponents";
import { Helmet } from "react-helmet";

import MainHeader from "../../common/MainHeader";

import CardListBox from "../../common/CardListBox";
import { Waypoint } from "react-waypoint";
import { contentCRM } from "./content";
const AutomatedCRM = ({ handleWaypointEnter, handleWaypointLeave }) => {
	return (
		<div>
			<Helmet>
				<title>Automation</title>
				<meta name="description" content="" />
			</Helmet>
			<MainHeader heading="Automated CRM" content="" />
			<Waypoint onEnter={handleWaypointEnter} onLeave={handleWaypointLeave} />

			<SecStartedContent>
				<ButtonTags selectedID={1} />
				<FlexDiv>
					<Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 20 }}>
						<EachBoxListingWrapper>
							{contentCRM.map((each) => {
								return <CardListBox each={each} />;
							})}
						</EachBoxListingWrapper>
					</Col>
				</FlexDiv>
			</SecStartedContent>
		</div>
	);
};

export default AutomatedCRM;
